/**
* @prop --uic-menu-bg-color: default background color
* @prop --uic-menu-bg-color-secondary: background color for variant `secondary`
* @prop --uic-menu-text-color: default text and icon color
*/
.uic-menu {
    display: block;
    position: relative;
    background-color: var(--uic-menu-bg-color);
    color: var(--uic-menu-text-color);

    .uic-menu__inner {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
    }

    &--vertical {
        .uic-menu__inner {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
        }
    }

    &--secondary {
        background-color: var(--uic-menu-bg-color-secondary);
    }
}
